/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * rain/v1/thread_service.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  AutomationClearThreadMemory200,
  AutomationClearThreadMemoryParams,
  AutomationDeleteAllThreads200,
  AutomationDeleteAllThreadsParams,
  AutomationDeleteArtifact200,
  AutomationDeleteArtifactParams,
  AutomationDeleteThread200,
  AutomationDeleteThreadParams,
  AutomationGetActivePlanParams,
  AutomationGetArtifactContentParams,
  AutomationGetArtifactDiffParams,
  AutomationGetArtifactParams,
  AutomationGetArtifactsStagingSummaryParams,
  AutomationGetEmbedderInfoParams,
  AutomationGetEventsParams,
  AutomationGetFilterSchemaParams,
  AutomationGetModelInfoParams,
  AutomationGetQueueParams,
  AutomationGetThreadContextParams,
  AutomationGetThreadCostSummaryParams,
  AutomationGetThreadCustomizationsParams,
  AutomationGetThreadMemoryBlockParams,
  AutomationGetThreadMemoryParams,
  AutomationGetThreadParams,
  AutomationGetToolParams,
  AutomationGetUtilityGeneratorModelInfoParams,
  AutomationListAllThreadsParams,
  AutomationListArtifactsParams,
  AutomationListThreadsParams,
  AutomationSendMessageSync200,
  AutomationSubscribeAgentThreadStatus200,
  AutomationSubscribeThread200,
  AutomationSubscribeThreadStatus200,
  AutomationTransfer200,
  RpcStatus,
  ThreadServiceActivatePlanBody,
  ThreadServiceCommitArtifactsBody,
  ThreadServiceCreateThreadBody,
  ThreadServiceDeactivatePlanBody,
  ThreadServiceDehydrateThreadBody,
  ThreadServiceDeleteEventBody,
  ThreadServiceDeployBody,
  ThreadServiceDiffArtifactsBody,
  ThreadServiceDiscardArtifactsBody,
  ThreadServiceEmbedAudioBatchBody,
  ThreadServiceEmbedAudioBody,
  ThreadServiceEmbedImageBatchBody,
  ThreadServiceEmbedImageBody,
  ThreadServiceEmbedTextBatchBody,
  ThreadServiceEmbedTextBody,
  ThreadServiceEmbedVideoBatchBody,
  ThreadServiceEmbedVideoBody,
  ThreadServiceForkThreadBody,
  ThreadServiceGrepArtifactsBody,
  ThreadServiceInvokeToolBody,
  ThreadServiceMarkStepBody,
  ThreadServiceRehydrateThreadBody,
  ThreadServiceResetConfigBody,
  ThreadServiceResetEventsBody,
  ThreadServiceResetPlanBody,
  ThreadServiceRestoreEventBody,
  ThreadServiceSendMessageBody,
  ThreadServiceSendMessageSyncBody,
  ThreadServiceSendToolCallBody,
  ThreadServiceSendToolResultBody,
  ThreadServiceSetFeedbackBody,
  ThreadServiceStartCompactionBody,
  ThreadServiceStopBody,
  ThreadServiceTransferBody,
  ThreadServiceUpdateArtifactBody,
  ThreadServiceUpdateThreadBody,
  ThreadServiceUpdateThreadMemoryBody,
  ThreadServiceUpgradeAllThreadsBody,
  ThreadServiceUpgradeThreadBody,
  ThreadServiceWakeBody,
  V1Artifact,
  V1ArtifactContentResponse,
  V1CommitArtifactsResponse,
  V1DeleteEventResponse,
  V1DeployResponse,
  V1DiffArtifactsResponse,
  V1DiscardArtifactsResponse,
  V1EmbedBatchResponse,
  V1EmbedResponse,
  V1EmbedderInfo,
  V1FilterSchemaResponse,
  V1GetArtifactDiffResponse,
  V1GetArtifactsStagingSummaryResponse,
  V1GetEventsResponse,
  V1GetQueueResponse,
  V1GetThreadContextResponse,
  V1GetThreadMemoryResponse,
  V1GrepArtifactsResponse,
  V1InvokeToolResponse,
  V1ListAllThreadsResponse,
  V1ListArtifactsResponse,
  V1ListThreadsResponse,
  V1ListToolsRequest,
  V1ListToolsResponse,
  V1MemoryBlock,
  V1ModelInfo,
  V1Plan,
  V1ResetConfigResponse,
  V1ResetEventsResponse,
  V1RestoreEventResponse,
  V1SendMessageResponse,
  V1SendToolCallResponse,
  V1SendToolResultResponse,
  V1SetFeedbackResponse,
  V1StartCompactionResponse,
  V1StopResponse,
  V1SubscribeAgentThreadStatusRequest,
  V1SubscribeThreadRequest,
  V1SubscribeThreadStatusRequest,
  V1Thread,
  V1ThreadCostSummary,
  V1ThreadCustomizationsResponse,
  V1Tool,
  V1UpgradeAllThreadsResponse,
  V1UpgradeThreadResponse,
  V1WakeResponse,
} from '../../models';

/**
 * @summary Lists all threads for an agent.
 */
export const automationListThreads = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  params?: AutomationListThreadsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListThreadsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationListThreadsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  params?: AutomationListThreadsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationListThreadsQueryOptions = <
  TData = Awaited<ReturnType<typeof automationListThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  params?: AutomationListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationListThreads>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationListThreadsQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationListThreads>>
  > = ({ signal }) =>
    automationListThreads(
      organization,
      workspace,
      automation,
      agentId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agentId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationListThreads>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationListThreadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationListThreads>>
>;
export type AutomationListThreadsQueryError = AxiosError<RpcStatus>;

export function useAutomationListThreads<
  TData = Awaited<ReturnType<typeof automationListThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  params: undefined | AutomationListThreadsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationListThreads>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationListThreads>>,
          TError,
          Awaited<ReturnType<typeof automationListThreads>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationListThreads<
  TData = Awaited<ReturnType<typeof automationListThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  params?: AutomationListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationListThreads>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationListThreads>>,
          TError,
          Awaited<ReturnType<typeof automationListThreads>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationListThreads<
  TData = Awaited<ReturnType<typeof automationListThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  params?: AutomationListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationListThreads>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all threads for an agent.
 */

export function useAutomationListThreads<
  TData = Awaited<ReturnType<typeof automationListThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  params?: AutomationListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationListThreads>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationListThreadsQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deletes all threads for an agent.
 */
export const automationDeleteAllThreads = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  params?: AutomationDeleteAllThreadsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AutomationDeleteAllThreads200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationDeleteAllThreadsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationDeleteAllThreads>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      params?: AutomationDeleteAllThreadsParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationDeleteAllThreads>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    params?: AutomationDeleteAllThreadsParams;
  },
  TContext
> => {
  const mutationKey = ['automationDeleteAllThreads'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationDeleteAllThreads>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      params?: AutomationDeleteAllThreadsParams;
    }
  > = props => {
    const { organization, workspace, automation, agentId, params } =
      props ?? {};

    return automationDeleteAllThreads(
      organization,
      workspace,
      automation,
      agentId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationDeleteAllThreadsMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationDeleteAllThreads>>
>;

export type AutomationDeleteAllThreadsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes all threads for an agent.
 */
export const useAutomationDeleteAllThreads = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationDeleteAllThreads>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        params?: AutomationDeleteAllThreadsParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationDeleteAllThreads>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    params?: AutomationDeleteAllThreadsParams;
  },
  TContext
> => {
  const mutationOptions = getAutomationDeleteAllThreadsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The thread_id is auto-generated. Optionally provide a title and description.
 * @summary Creates a new thread.
 */
export const automationCreateThread = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadServiceCreateThreadBody: ThreadServiceCreateThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads`,
    threadServiceCreateThreadBody,
    options,
  );
};

export const getAutomationCreateThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationCreateThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      data: ThreadServiceCreateThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationCreateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    data: ThreadServiceCreateThreadBody;
  },
  TContext
> => {
  const mutationKey = ['automationCreateThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationCreateThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      data: ThreadServiceCreateThreadBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, data } = props ?? {};

    return automationCreateThread(
      organization,
      workspace,
      automation,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationCreateThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationCreateThread>>
>;
export type AutomationCreateThreadMutationBody = ThreadServiceCreateThreadBody;
export type AutomationCreateThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates a new thread.
 */
export const useAutomationCreateThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationCreateThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        data: ThreadServiceCreateThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationCreateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    data: ThreadServiceCreateThreadBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationCreateThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns thread metadata and event count without loading the full event history.
Returns NOT_FOUND if the thread doesn't exist.
 * @summary Gets a thread by ID.
 */
export const automationGetThread = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetThreadQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  params?: AutomationGetThreadParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetThreadQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThread>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetThreadQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetThread>>
  > = ({ signal }) =>
    automationGetThread(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetThread>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetThreadQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetThread>>
>;
export type AutomationGetThreadQueryError = AxiosError<RpcStatus>;

export function useAutomationGetThread<
  TData = Awaited<ReturnType<typeof automationGetThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params: undefined | AutomationGetThreadParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThread>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetThread>>,
          TError,
          Awaited<ReturnType<typeof automationGetThread>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetThread<
  TData = Awaited<ReturnType<typeof automationGetThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThread>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetThread>>,
          TError,
          Awaited<ReturnType<typeof automationGetThread>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetThread<
  TData = Awaited<ReturnType<typeof automationGetThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThread>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a thread by ID.
 */

export function useAutomationGetThread<
  TData = Awaited<ReturnType<typeof automationGetThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThread>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetThreadQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deletes a thread and all its events.
 */
export const automationDeleteThread = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationDeleteThreadParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AutomationDeleteThread200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationDeleteThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationDeleteThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      params?: AutomationDeleteThreadParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationDeleteThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    params?: AutomationDeleteThreadParams;
  },
  TContext
> => {
  const mutationKey = ['automationDeleteThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationDeleteThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      params?: AutomationDeleteThreadParams;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, params } =
      props ?? {};

    return automationDeleteThread(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationDeleteThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationDeleteThread>>
>;

export type AutomationDeleteThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes a thread and all its events.
 */
export const useAutomationDeleteThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationDeleteThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        params?: AutomationDeleteThreadParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationDeleteThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    params?: AutomationDeleteThreadParams;
  },
  TContext
> => {
  const mutationOptions = getAutomationDeleteThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates a thread's title and/or description.
 */
export const automationUpdateThread = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceUpdateThreadBody: ThreadServiceUpdateThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}`,
    threadServiceUpdateThreadBody,
    options,
  );
};

export const getAutomationUpdateThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationUpdateThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceUpdateThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationUpdateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceUpdateThreadBody;
  },
  TContext
> => {
  const mutationKey = ['automationUpdateThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationUpdateThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceUpdateThreadBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationUpdateThread(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationUpdateThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationUpdateThread>>
>;
export type AutomationUpdateThreadMutationBody = ThreadServiceUpdateThreadBody;
export type AutomationUpdateThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates a thread's title and/or description.
 */
export const useAutomationUpdateThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationUpdateThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceUpdateThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationUpdateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceUpdateThreadBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationUpdateThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This promotes the thread's per-thread config to become the new agent defaults.
The thread's customization remains in place.
 * @summary Deploys the thread's config customizations to the agent template.
 */
export const automationDeploy = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceDeployBody: ThreadServiceDeployBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DeployResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/agent:deploy`,
    threadServiceDeployBody,
    options,
  );
};

export const getAutomationDeployMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationDeploy>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeployBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationDeploy>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeployBody;
  },
  TContext
> => {
  const mutationKey = ['automationDeploy'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationDeploy>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeployBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationDeploy(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationDeployMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationDeploy>>
>;
export type AutomationDeployMutationBody = ThreadServiceDeployBody;
export type AutomationDeployMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deploys the thread's config customizations to the agent template.
 */
export const useAutomationDeploy = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationDeploy>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDeployBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationDeploy>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeployBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationDeployMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * After reset, the thread will use the agent's default generator and config.
 * @summary ============================================================================
Reset & Deploy
============================================================================
Resets all per-thread config customizations to agent defaults.
 */
export const automationResetConfig = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceResetConfigBody: ThreadServiceResetConfigBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ResetConfigResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/agent:reset`,
    threadServiceResetConfigBody,
    options,
  );
};

export const getAutomationResetConfigMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationResetConfig>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetConfigBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationResetConfig>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetConfigBody;
  },
  TContext
> => {
  const mutationKey = ['automationResetConfig'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationResetConfig>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetConfigBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationResetConfig(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationResetConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationResetConfig>>
>;
export type AutomationResetConfigMutationBody = ThreadServiceResetConfigBody;
export type AutomationResetConfigMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Reset & Deploy
============================================================================
Resets all per-thread config customizations to agent defaults.
 */
export const useAutomationResetConfig = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationResetConfig>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceResetConfigBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationResetConfig>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetConfigBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationResetConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Threads are version-pinned at creation time and only this explicit
call moves them. The thread's per-thread template-group overrides
survive verbatim; the new version becomes the base they layer
onto. Downgrades and same-version targets are rejected. If the
target template requires variables the thread doesn't carry, the
response's `missing_variables` is populated and no state is
mutated — the caller re-prompts and re-issues.
 * @summary Moves a thread's pin to a different agent version.
 */
export const automationUpgradeThread = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceUpgradeThreadBody: ThreadServiceUpgradeThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UpgradeThreadResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/agent:upgrade`,
    threadServiceUpgradeThreadBody,
    options,
  );
};

export const getAutomationUpgradeThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationUpgradeThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceUpgradeThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationUpgradeThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceUpgradeThreadBody;
  },
  TContext
> => {
  const mutationKey = ['automationUpgradeThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationUpgradeThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceUpgradeThreadBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationUpgradeThread(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationUpgradeThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationUpgradeThread>>
>;
export type AutomationUpgradeThreadMutationBody =
  ThreadServiceUpgradeThreadBody;
export type AutomationUpgradeThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Moves a thread's pin to a different agent version.
 */
export const useAutomationUpgradeThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationUpgradeThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceUpgradeThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationUpgradeThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceUpgradeThreadBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationUpgradeThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ============================================================================
Artifact CRUD (Thread-Scoped)
============================================================================
Lists artifacts with optional filters.
Supports S3-style delimiter for folder navigation.
Thread ID is required for variable-scoped artifact access.
 */
export const automationListArtifacts = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationListArtifactsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListArtifactsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationListArtifactsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  params?: AutomationListArtifactsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationListArtifactsQueryOptions = <
  TData = Awaited<ReturnType<typeof automationListArtifacts>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationListArtifactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationListArtifacts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationListArtifactsQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationListArtifacts>>
  > = ({ signal }) =>
    automationListArtifacts(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationListArtifacts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationListArtifactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationListArtifacts>>
>;
export type AutomationListArtifactsQueryError = AxiosError<RpcStatus>;

export function useAutomationListArtifacts<
  TData = Awaited<ReturnType<typeof automationListArtifacts>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params: undefined | AutomationListArtifactsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationListArtifacts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationListArtifacts>>,
          TError,
          Awaited<ReturnType<typeof automationListArtifacts>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationListArtifacts<
  TData = Awaited<ReturnType<typeof automationListArtifacts>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationListArtifactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationListArtifacts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationListArtifacts>>,
          TError,
          Awaited<ReturnType<typeof automationListArtifacts>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationListArtifacts<
  TData = Awaited<ReturnType<typeof automationListArtifacts>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationListArtifactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationListArtifacts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Artifact CRUD (Thread-Scoped)
============================================================================
Lists artifacts with optional filters.
Supports S3-style delimiter for folder navigation.
Thread ID is required for variable-scoped artifact access.
 */

export function useAutomationListArtifacts<
  TData = Awaited<ReturnType<typeof automationListArtifacts>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationListArtifactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationListArtifacts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationListArtifactsQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets artifact metadata by URI.
 */
export const automationGetArtifact = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationGetArtifactParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Artifact>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetArtifactQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  artifactUri?: string,
  params?: AutomationGetArtifactParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetArtifactQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetArtifact>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationGetArtifactParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifact>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetArtifactQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      artifactUri,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetArtifact>>
  > = ({ signal }) =>
    automationGetArtifact(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      artifactUri,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      agentId &&
      threadId &&
      artifactUri
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetArtifact>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetArtifactQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetArtifact>>
>;
export type AutomationGetArtifactQueryError = AxiosError<RpcStatus>;

export function useAutomationGetArtifact<
  TData = Awaited<ReturnType<typeof automationGetArtifact>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params: undefined | AutomationGetArtifactParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifact>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetArtifact>>,
          TError,
          Awaited<ReturnType<typeof automationGetArtifact>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetArtifact<
  TData = Awaited<ReturnType<typeof automationGetArtifact>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationGetArtifactParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifact>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetArtifact>>,
          TError,
          Awaited<ReturnType<typeof automationGetArtifact>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetArtifact<
  TData = Awaited<ReturnType<typeof automationGetArtifact>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationGetArtifactParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifact>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets artifact metadata by URI.
 */

export function useAutomationGetArtifact<
  TData = Awaited<ReturnType<typeof automationGetArtifact>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationGetArtifactParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifact>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetArtifactQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    artifactUri,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deletes an artifact by URI.
 */
export const automationDeleteArtifact = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationDeleteArtifactParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AutomationDeleteArtifact200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationDeleteArtifactMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationDeleteArtifact>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      artifactUri: string;
      params?: AutomationDeleteArtifactParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationDeleteArtifact>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    artifactUri: string;
    params?: AutomationDeleteArtifactParams;
  },
  TContext
> => {
  const mutationKey = ['automationDeleteArtifact'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationDeleteArtifact>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      artifactUri: string;
      params?: AutomationDeleteArtifactParams;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      artifactUri,
      params,
    } = props ?? {};

    return automationDeleteArtifact(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      artifactUri,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationDeleteArtifactMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationDeleteArtifact>>
>;

export type AutomationDeleteArtifactMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes an artifact by URI.
 */
export const useAutomationDeleteArtifact = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationDeleteArtifact>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        artifactUri: string;
        params?: AutomationDeleteArtifactParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationDeleteArtifact>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    artifactUri: string;
    params?: AutomationDeleteArtifactParams;
  },
  TContext
> => {
  const mutationOptions = getAutomationDeleteArtifactMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Creates or updates an artifact.
 */
export const automationUpdateArtifact = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  threadServiceUpdateArtifactBody: ThreadServiceUpdateArtifactBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Artifact>> => {
  return axios.default.put(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}`,
    threadServiceUpdateArtifactBody,
    options,
  );
};

export const getAutomationUpdateArtifactMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationUpdateArtifact>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      artifactUri: string;
      data: ThreadServiceUpdateArtifactBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationUpdateArtifact>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    artifactUri: string;
    data: ThreadServiceUpdateArtifactBody;
  },
  TContext
> => {
  const mutationKey = ['automationUpdateArtifact'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationUpdateArtifact>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      artifactUri: string;
      data: ThreadServiceUpdateArtifactBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      artifactUri,
      data,
    } = props ?? {};

    return automationUpdateArtifact(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      artifactUri,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationUpdateArtifactMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationUpdateArtifact>>
>;
export type AutomationUpdateArtifactMutationBody =
  ThreadServiceUpdateArtifactBody;
export type AutomationUpdateArtifactMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates or updates an artifact.
 */
export const useAutomationUpdateArtifact = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationUpdateArtifact>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        artifactUri: string;
        data: ThreadServiceUpdateArtifactBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationUpdateArtifact>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    artifactUri: string;
    data: ThreadServiceUpdateArtifactBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationUpdateArtifactMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets artifact content by URI.
 */
export const automationGetArtifactContent = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationGetArtifactContentParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ArtifactContentResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}:content`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetArtifactContentQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  artifactUri?: string,
  params?: AutomationGetArtifactContentParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}:content`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetArtifactContentQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetArtifactContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationGetArtifactContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifactContent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetArtifactContentQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      artifactUri,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetArtifactContent>>
  > = ({ signal }) =>
    automationGetArtifactContent(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      artifactUri,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      agentId &&
      threadId &&
      artifactUri
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetArtifactContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetArtifactContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetArtifactContent>>
>;
export type AutomationGetArtifactContentQueryError = AxiosError<RpcStatus>;

export function useAutomationGetArtifactContent<
  TData = Awaited<ReturnType<typeof automationGetArtifactContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params: undefined | AutomationGetArtifactContentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifactContent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetArtifactContent>>,
          TError,
          Awaited<ReturnType<typeof automationGetArtifactContent>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetArtifactContent<
  TData = Awaited<ReturnType<typeof automationGetArtifactContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationGetArtifactContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifactContent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetArtifactContent>>,
          TError,
          Awaited<ReturnType<typeof automationGetArtifactContent>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetArtifactContent<
  TData = Awaited<ReturnType<typeof automationGetArtifactContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationGetArtifactContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifactContent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets artifact content by URI.
 */

export function useAutomationGetArtifactContent<
  TData = Awaited<ReturnType<typeof automationGetArtifactContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationGetArtifactContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifactContent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetArtifactContentQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    artifactUri,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the unified diff for a specific artifact if it has staged changes.
Returns empty diff for binary files or if no changes exist.
 * @summary Gets the diff for a single staged artifact.
 */
export const automationGetArtifactDiff = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationGetArtifactDiffParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetArtifactDiffResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}:diff`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetArtifactDiffQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  artifactUri?: string,
  params?: AutomationGetArtifactDiffParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}:diff`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetArtifactDiffQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetArtifactDiff>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationGetArtifactDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifactDiff>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetArtifactDiffQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      artifactUri,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetArtifactDiff>>
  > = ({ signal }) =>
    automationGetArtifactDiff(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      artifactUri,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      agentId &&
      threadId &&
      artifactUri
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetArtifactDiff>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetArtifactDiffQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetArtifactDiff>>
>;
export type AutomationGetArtifactDiffQueryError = AxiosError<RpcStatus>;

export function useAutomationGetArtifactDiff<
  TData = Awaited<ReturnType<typeof automationGetArtifactDiff>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params: undefined | AutomationGetArtifactDiffParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifactDiff>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetArtifactDiff>>,
          TError,
          Awaited<ReturnType<typeof automationGetArtifactDiff>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetArtifactDiff<
  TData = Awaited<ReturnType<typeof automationGetArtifactDiff>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationGetArtifactDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifactDiff>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetArtifactDiff>>,
          TError,
          Awaited<ReturnType<typeof automationGetArtifactDiff>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetArtifactDiff<
  TData = Awaited<ReturnType<typeof automationGetArtifactDiff>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationGetArtifactDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifactDiff>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets the diff for a single staged artifact.
 */

export function useAutomationGetArtifactDiff<
  TData = Awaited<ReturnType<typeof automationGetArtifactDiff>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: AutomationGetArtifactDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifactDiff>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetArtifactDiffQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    artifactUri,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Persists all staged changes (additions, modifications, deletions) to
the underlying store. For stores without staging, this is a no-op.
 * @summary Commits staged artifact changes to the underlying store.
 */
export const automationCommitArtifacts = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceCommitArtifactsBody: ThreadServiceCommitArtifactsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CommitArtifactsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts:commit`,
    threadServiceCommitArtifactsBody,
    options,
  );
};

export const getAutomationCommitArtifactsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationCommitArtifacts>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceCommitArtifactsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationCommitArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceCommitArtifactsBody;
  },
  TContext
> => {
  const mutationKey = ['automationCommitArtifacts'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationCommitArtifacts>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceCommitArtifactsBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationCommitArtifacts(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationCommitArtifactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationCommitArtifacts>>
>;
export type AutomationCommitArtifactsMutationBody =
  ThreadServiceCommitArtifactsBody;
export type AutomationCommitArtifactsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Commits staged artifact changes to the underlying store.
 */
export const useAutomationCommitArtifacts = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationCommitArtifacts>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceCommitArtifactsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationCommitArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceCommitArtifactsBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationCommitArtifactsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns information about artifacts that have been modified but not yet
committed. For stores with staging enabled, this shows pending changes.
For stores without staging, returns an empty response.
 * @summary Gets staged artifact changes with optional diff content.
 */
export const automationDiffArtifacts = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceDiffArtifactsBody: ThreadServiceDiffArtifactsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DiffArtifactsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts:diff`,
    threadServiceDiffArtifactsBody,
    options,
  );
};

export const getAutomationDiffArtifactsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationDiffArtifacts>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDiffArtifactsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationDiffArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDiffArtifactsBody;
  },
  TContext
> => {
  const mutationKey = ['automationDiffArtifacts'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationDiffArtifacts>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDiffArtifactsBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationDiffArtifacts(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationDiffArtifactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationDiffArtifacts>>
>;
export type AutomationDiffArtifactsMutationBody =
  ThreadServiceDiffArtifactsBody;
export type AutomationDiffArtifactsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Gets staged artifact changes with optional diff content.
 */
export const useAutomationDiffArtifacts = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationDiffArtifacts>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDiffArtifactsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationDiffArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDiffArtifactsBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationDiffArtifactsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Clears all pending changes (additions, modifications, deletions) from
the staging area. For stores without staging, this is a no-op.
 * @summary Discards all staged artifact changes without committing.
 */
export const automationDiscardArtifacts = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceDiscardArtifactsBody: ThreadServiceDiscardArtifactsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DiscardArtifactsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts:discard`,
    threadServiceDiscardArtifactsBody,
    options,
  );
};

export const getAutomationDiscardArtifactsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationDiscardArtifacts>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDiscardArtifactsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationDiscardArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDiscardArtifactsBody;
  },
  TContext
> => {
  const mutationKey = ['automationDiscardArtifacts'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationDiscardArtifacts>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDiscardArtifactsBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationDiscardArtifacts(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationDiscardArtifactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationDiscardArtifacts>>
>;
export type AutomationDiscardArtifactsMutationBody =
  ThreadServiceDiscardArtifactsBody;
export type AutomationDiscardArtifactsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Discards all staged artifact changes without committing.
 */
export const useAutomationDiscardArtifacts = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationDiscardArtifacts>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDiscardArtifactsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationDiscardArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDiscardArtifactsBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationDiscardArtifactsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ============================================================================
Search (Thread-Scoped)
============================================================================
Searches artifact contents using regex pattern matching.
 */
export const automationGrepArtifacts = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceGrepArtifactsBody: ThreadServiceGrepArtifactsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GrepArtifactsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts:grep`,
    threadServiceGrepArtifactsBody,
    options,
  );
};

export const getAutomationGrepArtifactsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationGrepArtifacts>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceGrepArtifactsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationGrepArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceGrepArtifactsBody;
  },
  TContext
> => {
  const mutationKey = ['automationGrepArtifacts'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationGrepArtifacts>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceGrepArtifactsBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationGrepArtifacts(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationGrepArtifactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationGrepArtifacts>>
>;
export type AutomationGrepArtifactsMutationBody =
  ThreadServiceGrepArtifactsBody;
export type AutomationGrepArtifactsMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Search (Thread-Scoped)
============================================================================
Searches artifact contents using regex pattern matching.
 */
export const useAutomationGrepArtifacts = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationGrepArtifacts>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceGrepArtifactsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationGrepArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceGrepArtifactsBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationGrepArtifactsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns a lightweight summary of pending changes including counts and
change metadata without diff content. Use DiffArtifacts for full diffs.
 * @summary ============================================================================
Staging (Thread-Scoped)
============================================================================
Gets a summary of staged artifact changes.
 */
export const automationGetArtifactsStagingSummary = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetArtifactsStagingSummaryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetArtifactsStagingSummaryResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts:staging`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetArtifactsStagingSummaryQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  params?: AutomationGetArtifactsStagingSummaryParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/artifacts:staging`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetArtifactsStagingSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetArtifactsStagingSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetArtifactsStagingSummaryQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>
  > = ({ signal }) =>
    automationGetArtifactsStagingSummary(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetArtifactsStagingSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>
>;
export type AutomationGetArtifactsStagingSummaryQueryError =
  AxiosError<RpcStatus>;

export function useAutomationGetArtifactsStagingSummary<
  TData = Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params: undefined | AutomationGetArtifactsStagingSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>,
          TError,
          Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetArtifactsStagingSummary<
  TData = Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetArtifactsStagingSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>,
          TError,
          Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetArtifactsStagingSummary<
  TData = Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetArtifactsStagingSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Staging (Thread-Scoped)
============================================================================
Gets a summary of staged artifact changes.
 */

export function useAutomationGetArtifactsStagingSummary<
  TData = Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetArtifactsStagingSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetArtifactsStagingSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetArtifactsStagingSummaryQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a unified view of all items contributing to the context window:
- Memory blocks (fixed and volatile)
- Enabled tools (fixed)
- Conversation history (compactable)

Each item includes its token count for context budget management.
 * @summary ============================================================================
Context Information (Thread-Scoped)
============================================================================
Gets thread context information including all context items with token counts.
 */
export const automationGetThreadContext = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadContextParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetThreadContextResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/context`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetThreadContextQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  params?: AutomationGetThreadContextParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/context`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetThreadContextQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetThreadContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadContext>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetThreadContextQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetThreadContext>>
  > = ({ signal }) =>
    automationGetThreadContext(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetThreadContext>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetThreadContextQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetThreadContext>>
>;
export type AutomationGetThreadContextQueryError = AxiosError<RpcStatus>;

export function useAutomationGetThreadContext<
  TData = Awaited<ReturnType<typeof automationGetThreadContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params: undefined | AutomationGetThreadContextParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadContext>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetThreadContext>>,
          TError,
          Awaited<ReturnType<typeof automationGetThreadContext>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetThreadContext<
  TData = Awaited<ReturnType<typeof automationGetThreadContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadContext>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetThreadContext>>,
          TError,
          Awaited<ReturnType<typeof automationGetThreadContext>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetThreadContext<
  TData = Awaited<ReturnType<typeof automationGetThreadContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadContext>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Context Information (Thread-Scoped)
============================================================================
Gets thread context information including all context items with token counts.
 */

export function useAutomationGetThreadContext<
  TData = Awaited<ReturnType<typeof automationGetThreadContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadContext>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetThreadContextQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Prices the thread's usage aggregate (and its sub-agent delegations)
against the current effective-dated rate card. USD is computed at read
time, never stored.
 * @summary Gets a thread's cost summary.
 */
export const automationGetThreadCostSummary = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadCostSummaryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ThreadCostSummary>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/cost`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetThreadCostSummaryQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  params?: AutomationGetThreadCostSummaryParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/cost`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetThreadCostSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetThreadCostSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadCostSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetThreadCostSummaryQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetThreadCostSummary>>
  > = ({ signal }) =>
    automationGetThreadCostSummary(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetThreadCostSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetThreadCostSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetThreadCostSummary>>
>;
export type AutomationGetThreadCostSummaryQueryError = AxiosError<RpcStatus>;

export function useAutomationGetThreadCostSummary<
  TData = Awaited<ReturnType<typeof automationGetThreadCostSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params: undefined | AutomationGetThreadCostSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadCostSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetThreadCostSummary>>,
          TError,
          Awaited<ReturnType<typeof automationGetThreadCostSummary>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetThreadCostSummary<
  TData = Awaited<ReturnType<typeof automationGetThreadCostSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadCostSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetThreadCostSummary>>,
          TError,
          Awaited<ReturnType<typeof automationGetThreadCostSummary>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetThreadCostSummary<
  TData = Awaited<ReturnType<typeof automationGetThreadCostSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadCostSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a thread's cost summary.
 */

export function useAutomationGetThreadCostSummary<
  TData = Awaited<ReturnType<typeof automationGetThreadCostSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadCostSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetThreadCostSummaryQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deliberately uncached so the Deploy gate stays fresh.
Returns NOT_FOUND if the thread doesn't exist.
 * @summary Reports the thread's per-thread config customizations in one read:
whether Deploy has anything to promote, which sections are
customized, and whether generated card state is present.
 */
export const automationGetThreadCustomizations = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadCustomizationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ThreadCustomizationsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/customizations`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetThreadCustomizationsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  params?: AutomationGetThreadCustomizationsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/customizations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetThreadCustomizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetThreadCustomizations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadCustomizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadCustomizations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetThreadCustomizationsQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetThreadCustomizations>>
  > = ({ signal }) =>
    automationGetThreadCustomizations(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetThreadCustomizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetThreadCustomizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetThreadCustomizations>>
>;
export type AutomationGetThreadCustomizationsQueryError = AxiosError<RpcStatus>;

export function useAutomationGetThreadCustomizations<
  TData = Awaited<ReturnType<typeof automationGetThreadCustomizations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params: undefined | AutomationGetThreadCustomizationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadCustomizations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetThreadCustomizations>>,
          TError,
          Awaited<ReturnType<typeof automationGetThreadCustomizations>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetThreadCustomizations<
  TData = Awaited<ReturnType<typeof automationGetThreadCustomizations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadCustomizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadCustomizations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetThreadCustomizations>>,
          TError,
          Awaited<ReturnType<typeof automationGetThreadCustomizations>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetThreadCustomizations<
  TData = Awaited<ReturnType<typeof automationGetThreadCustomizations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadCustomizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadCustomizations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Reports the thread's per-thread config customizations in one read:
whether Deploy has anything to promote, which sections are
customized, and whether generated card state is present.
 */

export function useAutomationGetThreadCustomizations<
  TData = Awaited<ReturnType<typeof automationGetThreadCustomizations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadCustomizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadCustomizations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetThreadCustomizationsQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The thread context is required because the embedder may depend on
variables that are resolved per-thread. Returns dimension, max input
length, normalization, and provider information. Returns NOT_FOUND if
the agent has no embedder configured.
 * @summary Gets embedder information and capabilities for the agent's embedder.
 */
export const automationGetEmbedderInfo = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetEmbedderInfoParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedderInfo>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/embedder-info`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetEmbedderInfoQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  params?: AutomationGetEmbedderInfoParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/embedder-info`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetEmbedderInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetEmbedderInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetEmbedderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetEmbedderInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetEmbedderInfoQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetEmbedderInfo>>
  > = ({ signal }) =>
    automationGetEmbedderInfo(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetEmbedderInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetEmbedderInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetEmbedderInfo>>
>;
export type AutomationGetEmbedderInfoQueryError = AxiosError<RpcStatus>;

export function useAutomationGetEmbedderInfo<
  TData = Awaited<ReturnType<typeof automationGetEmbedderInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params: undefined | AutomationGetEmbedderInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetEmbedderInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetEmbedderInfo>>,
          TError,
          Awaited<ReturnType<typeof automationGetEmbedderInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetEmbedderInfo<
  TData = Awaited<ReturnType<typeof automationGetEmbedderInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetEmbedderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetEmbedderInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetEmbedderInfo>>,
          TError,
          Awaited<ReturnType<typeof automationGetEmbedderInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetEmbedderInfo<
  TData = Awaited<ReturnType<typeof automationGetEmbedderInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetEmbedderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetEmbedderInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets embedder information and capabilities for the agent's embedder.
 */

export function useAutomationGetEmbedderInfo<
  TData = Awaited<ReturnType<typeof automationGetEmbedderInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetEmbedderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetEmbedderInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetEmbedderInfoQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Generates an embedding for a single audio clip.
 */
export const automationEmbedAudio = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedAudioBody: ThreadServiceEmbedAudioBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/embedder:embed-audio`,
    threadServiceEmbedAudioBody,
    options,
  );
};

export const getAutomationEmbedAudioMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationEmbedAudio>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedAudioBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationEmbedAudio>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedAudioBody;
  },
  TContext
> => {
  const mutationKey = ['automationEmbedAudio'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationEmbedAudio>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedAudioBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationEmbedAudio(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationEmbedAudioMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationEmbedAudio>>
>;
export type AutomationEmbedAudioMutationBody = ThreadServiceEmbedAudioBody;
export type AutomationEmbedAudioMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates an embedding for a single audio clip.
 */
export const useAutomationEmbedAudio = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationEmbedAudio>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedAudioBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationEmbedAudio>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedAudioBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationEmbedAudioMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates embeddings for a batch of audio clips.
 */
export const automationEmbedAudioBatch = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedAudioBatchBody: ThreadServiceEmbedAudioBatchBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedBatchResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/embedder:embed-audio-batch`,
    threadServiceEmbedAudioBatchBody,
    options,
  );
};

export const getAutomationEmbedAudioBatchMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationEmbedAudioBatch>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedAudioBatchBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationEmbedAudioBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedAudioBatchBody;
  },
  TContext
> => {
  const mutationKey = ['automationEmbedAudioBatch'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationEmbedAudioBatch>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedAudioBatchBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationEmbedAudioBatch(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationEmbedAudioBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationEmbedAudioBatch>>
>;
export type AutomationEmbedAudioBatchMutationBody =
  ThreadServiceEmbedAudioBatchBody;
export type AutomationEmbedAudioBatchMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates embeddings for a batch of audio clips.
 */
export const useAutomationEmbedAudioBatch = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationEmbedAudioBatch>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedAudioBatchBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationEmbedAudioBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedAudioBatchBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationEmbedAudioBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates an embedding for a single image (encoded bytes).
 */
export const automationEmbedImage = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedImageBody: ThreadServiceEmbedImageBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/embedder:embed-image`,
    threadServiceEmbedImageBody,
    options,
  );
};

export const getAutomationEmbedImageMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationEmbedImage>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedImageBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationEmbedImage>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedImageBody;
  },
  TContext
> => {
  const mutationKey = ['automationEmbedImage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationEmbedImage>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedImageBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationEmbedImage(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationEmbedImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationEmbedImage>>
>;
export type AutomationEmbedImageMutationBody = ThreadServiceEmbedImageBody;
export type AutomationEmbedImageMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates an embedding for a single image (encoded bytes).
 */
export const useAutomationEmbedImage = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationEmbedImage>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedImageBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationEmbedImage>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedImageBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationEmbedImageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates embeddings for a batch of images.
 */
export const automationEmbedImageBatch = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedImageBatchBody: ThreadServiceEmbedImageBatchBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedBatchResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/embedder:embed-image-batch`,
    threadServiceEmbedImageBatchBody,
    options,
  );
};

export const getAutomationEmbedImageBatchMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationEmbedImageBatch>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedImageBatchBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationEmbedImageBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedImageBatchBody;
  },
  TContext
> => {
  const mutationKey = ['automationEmbedImageBatch'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationEmbedImageBatch>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedImageBatchBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationEmbedImageBatch(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationEmbedImageBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationEmbedImageBatch>>
>;
export type AutomationEmbedImageBatchMutationBody =
  ThreadServiceEmbedImageBatchBody;
export type AutomationEmbedImageBatchMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates embeddings for a batch of images.
 */
export const useAutomationEmbedImageBatch = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationEmbedImageBatch>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedImageBatchBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationEmbedImageBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedImageBatchBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationEmbedImageBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns NOT_FOUND if the agent has no embedder configured, or
FAILED_PRECONDITION if the configured embedder doesn't support text.
 * @summary Generates an embedding for a single text input.
 */
export const automationEmbedText = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedTextBody: ThreadServiceEmbedTextBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/embedder:embed-text`,
    threadServiceEmbedTextBody,
    options,
  );
};

export const getAutomationEmbedTextMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationEmbedText>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedTextBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationEmbedText>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedTextBody;
  },
  TContext
> => {
  const mutationKey = ['automationEmbedText'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationEmbedText>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedTextBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationEmbedText(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationEmbedTextMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationEmbedText>>
>;
export type AutomationEmbedTextMutationBody = ThreadServiceEmbedTextBody;
export type AutomationEmbedTextMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates an embedding for a single text input.
 */
export const useAutomationEmbedText = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationEmbedText>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedTextBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationEmbedText>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedTextBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationEmbedTextMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates embeddings for a batch of text inputs.
 */
export const automationEmbedTextBatch = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedTextBatchBody: ThreadServiceEmbedTextBatchBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedBatchResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/embedder:embed-text-batch`,
    threadServiceEmbedTextBatchBody,
    options,
  );
};

export const getAutomationEmbedTextBatchMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationEmbedTextBatch>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedTextBatchBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationEmbedTextBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedTextBatchBody;
  },
  TContext
> => {
  const mutationKey = ['automationEmbedTextBatch'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationEmbedTextBatch>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedTextBatchBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationEmbedTextBatch(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationEmbedTextBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationEmbedTextBatch>>
>;
export type AutomationEmbedTextBatchMutationBody =
  ThreadServiceEmbedTextBatchBody;
export type AutomationEmbedTextBatchMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates embeddings for a batch of text inputs.
 */
export const useAutomationEmbedTextBatch = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationEmbedTextBatch>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedTextBatchBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationEmbedTextBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedTextBatchBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationEmbedTextBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates an embedding for a single video clip.
 */
export const automationEmbedVideo = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedVideoBody: ThreadServiceEmbedVideoBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/embedder:embed-video`,
    threadServiceEmbedVideoBody,
    options,
  );
};

export const getAutomationEmbedVideoMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationEmbedVideo>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedVideoBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationEmbedVideo>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedVideoBody;
  },
  TContext
> => {
  const mutationKey = ['automationEmbedVideo'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationEmbedVideo>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedVideoBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationEmbedVideo(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationEmbedVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationEmbedVideo>>
>;
export type AutomationEmbedVideoMutationBody = ThreadServiceEmbedVideoBody;
export type AutomationEmbedVideoMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates an embedding for a single video clip.
 */
export const useAutomationEmbedVideo = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationEmbedVideo>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedVideoBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationEmbedVideo>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedVideoBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationEmbedVideoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates embeddings for a batch of video clips.
 */
export const automationEmbedVideoBatch = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedVideoBatchBody: ThreadServiceEmbedVideoBatchBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedBatchResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/embedder:embed-video-batch`,
    threadServiceEmbedVideoBatchBody,
    options,
  );
};

export const getAutomationEmbedVideoBatchMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationEmbedVideoBatch>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedVideoBatchBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationEmbedVideoBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedVideoBatchBody;
  },
  TContext
> => {
  const mutationKey = ['automationEmbedVideoBatch'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationEmbedVideoBatch>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedVideoBatchBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationEmbedVideoBatch(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationEmbedVideoBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationEmbedVideoBatch>>
>;
export type AutomationEmbedVideoBatchMutationBody =
  ThreadServiceEmbedVideoBatchBody;
export type AutomationEmbedVideoBatchMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates embeddings for a batch of video clips.
 */
export const useAutomationEmbedVideoBatch = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationEmbedVideoBatch>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedVideoBatchBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationEmbedVideoBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedVideoBatchBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationEmbedVideoBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This RPC returns the complete history of events for a thread, including
user inputs, assistant responses, tool calls, and their results.
Events are returned in chronological order.
 * @summary Retrieves all events from a thread.
 */
export const automationGetEvents = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetEventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetEventsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/events`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetEventsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  params?: AutomationGetEventsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/events`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetEvents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetEventsQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetEvents>>
  > = ({ signal }) =>
    automationGetEvents(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetEvents>>
>;
export type AutomationGetEventsQueryError = AxiosError<RpcStatus>;

export function useAutomationGetEvents<
  TData = Awaited<ReturnType<typeof automationGetEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params: undefined | AutomationGetEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetEvents>>,
          TError,
          Awaited<ReturnType<typeof automationGetEvents>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetEvents<
  TData = Awaited<ReturnType<typeof automationGetEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetEvents>>,
          TError,
          Awaited<ReturnType<typeof automationGetEvents>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetEvents<
  TData = Awaited<ReturnType<typeof automationGetEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetEvents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves all events from a thread.
 */

export function useAutomationGetEvents<
  TData = Awaited<ReturnType<typeof automationGetEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetEvents>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetEventsQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This RPC adds user input to the specified thread and returns a stream
of events representing the assistant's response. Events include output text,
tool calls, and completion metadata.
 * @summary ============================================================================
Events
============================================================================
Sends a message and streams back response events synchronously.
 */
export const automationSendMessageSync = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceSendMessageSyncBody: ThreadServiceSendMessageSyncBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AutomationSendMessageSync200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/events`,
    threadServiceSendMessageSyncBody,
    options,
  );
};

export const getAutomationSendMessageSyncMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationSendMessageSync>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendMessageSyncBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationSendMessageSync>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendMessageSyncBody;
  },
  TContext
> => {
  const mutationKey = ['automationSendMessageSync'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationSendMessageSync>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendMessageSyncBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationSendMessageSync(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationSendMessageSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationSendMessageSync>>
>;
export type AutomationSendMessageSyncMutationBody =
  ThreadServiceSendMessageSyncBody;
export type AutomationSendMessageSyncMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Events
============================================================================
Sends a message and streams back response events synchronously.
 */
export const useAutomationSendMessageSync = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationSendMessageSync>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceSendMessageSyncBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationSendMessageSync>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendMessageSyncBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationSendMessageSyncMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Deletes an event and its entire associated turn from the thread.
 */
export const automationDeleteEvent = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceDeleteEventBody: ThreadServiceDeleteEventBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DeleteEventResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/events:delete`,
    threadServiceDeleteEventBody,
    options,
  );
};

export const getAutomationDeleteEventMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationDeleteEvent>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeleteEventBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationDeleteEvent>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeleteEventBody;
  },
  TContext
> => {
  const mutationKey = ['automationDeleteEvent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationDeleteEvent>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeleteEventBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationDeleteEvent(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationDeleteEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationDeleteEvent>>
>;
export type AutomationDeleteEventMutationBody = ThreadServiceDeleteEventBody;
export type AutomationDeleteEventMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes an event and its entire associated turn from the thread.
 */
export const useAutomationDeleteEvent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationDeleteEvent>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDeleteEventBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationDeleteEvent>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeleteEventBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationDeleteEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Clears the entire event history and associated feedback while preserving
all other thread state (plan, memory customizations, config customizations, scratchpad).
Returns FAILED_PRECONDITION if the thread is currently generating.
 * @summary Resets all events and feedback in a thread.
 */
export const automationResetEvents = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceResetEventsBody: ThreadServiceResetEventsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ResetEventsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/events:reset`,
    threadServiceResetEventsBody,
    options,
  );
};

export const getAutomationResetEventsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationResetEvents>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetEventsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationResetEvents>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetEventsBody;
  },
  TContext
> => {
  const mutationKey = ['automationResetEvents'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationResetEvents>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetEventsBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationResetEvents(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationResetEventsMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationResetEvents>>
>;
export type AutomationResetEventsMutationBody = ThreadServiceResetEventsBody;
export type AutomationResetEventsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Resets all events and feedback in a thread.
 */
export const useAutomationResetEvents = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationResetEvents>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceResetEventsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationResetEvents>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetEventsBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationResetEventsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Restores a previously deleted event and its entire associated turn.
 */
export const automationRestoreEvent = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceRestoreEventBody: ThreadServiceRestoreEventBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RestoreEventResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/events:restore`,
    threadServiceRestoreEventBody,
    options,
  );
};

export const getAutomationRestoreEventMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationRestoreEvent>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceRestoreEventBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationRestoreEvent>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceRestoreEventBody;
  },
  TContext
> => {
  const mutationKey = ['automationRestoreEvent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationRestoreEvent>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceRestoreEventBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationRestoreEvent(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationRestoreEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationRestoreEvent>>
>;
export type AutomationRestoreEventMutationBody = ThreadServiceRestoreEventBody;
export type AutomationRestoreEventMutationError = AxiosError<RpcStatus>;

/**
 * @summary Restores a previously deleted event and its entire associated turn.
 */
export const useAutomationRestoreEvent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationRestoreEvent>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceRestoreEventBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationRestoreEvent>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceRestoreEventBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationRestoreEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Feedback is mutually exclusive - setting LIKE removes any DISLIKE and vice versa.
Setting the same feedback that already exists is a no-op.
Use FEEDBACK_TYPE_UNSPECIFIED to clear existing feedback.

Feedback is stored with the thread and is purely for analytics/UI purposes.
It is not visible to the LLM.
 * @summary ============================================================================
Feedback
============================================================================
Sets feedback (like/dislike) for a generation response.
 */
export const automationSetFeedback = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceSetFeedbackBody: ThreadServiceSetFeedbackBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SetFeedbackResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/feedback`,
    threadServiceSetFeedbackBody,
    options,
  );
};

export const getAutomationSetFeedbackMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationSetFeedback>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSetFeedbackBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationSetFeedback>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSetFeedbackBody;
  },
  TContext
> => {
  const mutationKey = ['automationSetFeedback'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationSetFeedback>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSetFeedbackBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationSetFeedback(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationSetFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationSetFeedback>>
>;
export type AutomationSetFeedbackMutationBody = ThreadServiceSetFeedbackBody;
export type AutomationSetFeedbackMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Feedback
============================================================================
Sets feedback (like/dislike) for a generation response.
 */
export const useAutomationSetFeedback = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationSetFeedback>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceSetFeedbackBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationSetFeedback>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSetFeedbackBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationSetFeedbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The thread context is required because the generator may depend on
variables that are resolved per-thread. Returns model capabilities
like supported features, token limits, and pricing information.
 * @summary ============================================================================
Model Info (Thread-Scoped)
============================================================================
Gets model information and capabilities for the agent's main generator.
 */
export const automationGetModelInfo = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetModelInfoParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ModelInfo>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/generator:model-info`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetModelInfoQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  params?: AutomationGetModelInfoParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/generator:model-info`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetModelInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetModelInfoQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetModelInfo>>
  > = ({ signal }) =>
    automationGetModelInfo(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetModelInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetModelInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetModelInfo>>
>;
export type AutomationGetModelInfoQueryError = AxiosError<RpcStatus>;

export function useAutomationGetModelInfo<
  TData = Awaited<ReturnType<typeof automationGetModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params: undefined | AutomationGetModelInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetModelInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetModelInfo>>,
          TError,
          Awaited<ReturnType<typeof automationGetModelInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetModelInfo<
  TData = Awaited<ReturnType<typeof automationGetModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetModelInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetModelInfo>>,
          TError,
          Awaited<ReturnType<typeof automationGetModelInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetModelInfo<
  TData = Awaited<ReturnType<typeof automationGetModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Model Info (Thread-Scoped)
============================================================================
Gets model information and capabilities for the agent's main generator.
 */

export function useAutomationGetModelInfo<
  TData = Awaited<ReturnType<typeof automationGetModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetModelInfoQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The message is added to the thread and generation begins asynchronously.
Response events arrive via SubscribeThread stream or SSE, not this RPC.
 * @summary Sends a message to a thread (fire and forget).
 */
export const automationSendMessage = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceSendMessageBody: ThreadServiceSendMessageBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SendMessageResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/input`,
    threadServiceSendMessageBody,
    options,
  );
};

export const getAutomationSendMessageMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationSendMessage>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendMessageBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationSendMessage>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendMessageBody;
  },
  TContext
> => {
  const mutationKey = ['automationSendMessage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationSendMessage>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendMessageBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationSendMessage(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationSendMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationSendMessage>>
>;
export type AutomationSendMessageMutationBody = ThreadServiceSendMessageBody;
export type AutomationSendMessageMutationError = AxiosError<RpcStatus>;

/**
 * @summary Sends a message to a thread (fire and forget).
 */
export const useAutomationSendMessage = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationSendMessage>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceSendMessageBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationSendMessage>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendMessageBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationSendMessageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns memory blocks with content resolved for the thread context:
- Agent-scoped blocks return base content
- Thread-scoped blocks return the thread's customization (or base if no override)

The runtime-content routes live under `/memory`; block config
templates (kind / scope / etc.) live under `/memory-blocks`
managed by `MemoryService`.
 * @summary ============================================================================
Thread Memory
============================================================================
Gets all memory blocks with resolved content for a thread.
 */
export const automationGetThreadMemory = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadMemoryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetThreadMemoryResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/memory`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetThreadMemoryQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  params?: AutomationGetThreadMemoryParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/memory`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetThreadMemoryQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetThreadMemory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadMemoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadMemory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetThreadMemoryQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetThreadMemory>>
  > = ({ signal }) =>
    automationGetThreadMemory(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetThreadMemory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetThreadMemoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetThreadMemory>>
>;
export type AutomationGetThreadMemoryQueryError = AxiosError<RpcStatus>;

export function useAutomationGetThreadMemory<
  TData = Awaited<ReturnType<typeof automationGetThreadMemory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params: undefined | AutomationGetThreadMemoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadMemory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetThreadMemory>>,
          TError,
          Awaited<ReturnType<typeof automationGetThreadMemory>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetThreadMemory<
  TData = Awaited<ReturnType<typeof automationGetThreadMemory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadMemoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadMemory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetThreadMemory>>,
          TError,
          Awaited<ReturnType<typeof automationGetThreadMemory>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetThreadMemory<
  TData = Awaited<ReturnType<typeof automationGetThreadMemory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadMemoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadMemory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Thread Memory
============================================================================
Gets all memory blocks with resolved content for a thread.
 */

export function useAutomationGetThreadMemory<
  TData = Awaited<ReturnType<typeof automationGetThreadMemory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetThreadMemoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadMemory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetThreadMemoryQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets a specific memory block with resolved content for a thread.
 */
export const automationGetThreadMemoryBlock = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: AutomationGetThreadMemoryBlockParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1MemoryBlock>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/memory/${blockId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetThreadMemoryBlockQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  blockId?: string,
  params?: AutomationGetThreadMemoryBlockParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/memory/${blockId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetThreadMemoryBlockQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: AutomationGetThreadMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetThreadMemoryBlockQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      blockId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>
  > = ({ signal }) =>
    automationGetThreadMemoryBlock(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      blockId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      agentId &&
      threadId &&
      blockId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetThreadMemoryBlockQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>
>;
export type AutomationGetThreadMemoryBlockQueryError = AxiosError<RpcStatus>;

export function useAutomationGetThreadMemoryBlock<
  TData = Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params: undefined | AutomationGetThreadMemoryBlockParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>,
          TError,
          Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetThreadMemoryBlock<
  TData = Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: AutomationGetThreadMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>,
          TError,
          Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetThreadMemoryBlock<
  TData = Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: AutomationGetThreadMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a specific memory block with resolved content for a thread.
 */

export function useAutomationGetThreadMemoryBlock<
  TData = Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: AutomationGetThreadMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetThreadMemoryBlock>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetThreadMemoryBlockQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    blockId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Only thread-scoped blocks can be cleared through this endpoint.
This removes the thread's customization, revealing the base content.
Agent-scoped blocks must be cleared through the MemoryService.
Returns FAILED_PRECONDITION if the block is agent-scoped.
 * @summary Clears memory block content in a thread context.
 */
export const automationClearThreadMemory = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: AutomationClearThreadMemoryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AutomationClearThreadMemory200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/memory/${blockId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationClearThreadMemoryMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationClearThreadMemory>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      blockId: string;
      params?: AutomationClearThreadMemoryParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationClearThreadMemory>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    blockId: string;
    params?: AutomationClearThreadMemoryParams;
  },
  TContext
> => {
  const mutationKey = ['automationClearThreadMemory'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationClearThreadMemory>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      blockId: string;
      params?: AutomationClearThreadMemoryParams;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      blockId,
      params,
    } = props ?? {};

    return automationClearThreadMemory(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      blockId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationClearThreadMemoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationClearThreadMemory>>
>;

export type AutomationClearThreadMemoryMutationError = AxiosError<RpcStatus>;

/**
 * @summary Clears memory block content in a thread context.
 */
export const useAutomationClearThreadMemory = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationClearThreadMemory>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        blockId: string;
        params?: AutomationClearThreadMemoryParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationClearThreadMemory>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    blockId: string;
    params?: AutomationClearThreadMemoryParams;
  },
  TContext
> => {
  const mutationOptions =
    getAutomationClearThreadMemoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Only thread-scoped blocks can be updated through this endpoint.
Agent-scoped blocks must be updated through the MemoryService.
Returns FAILED_PRECONDITION if the block is agent-scoped.
 * @summary Updates memory block content in a thread context.
 */
export const automationUpdateThreadMemory = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  blockId: string,
  threadServiceUpdateThreadMemoryBody: ThreadServiceUpdateThreadMemoryBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1MemoryBlock>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/memory/${blockId}`,
    threadServiceUpdateThreadMemoryBody,
    options,
  );
};

export const getAutomationUpdateThreadMemoryMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationUpdateThreadMemory>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      blockId: string;
      data: ThreadServiceUpdateThreadMemoryBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationUpdateThreadMemory>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    blockId: string;
    data: ThreadServiceUpdateThreadMemoryBody;
  },
  TContext
> => {
  const mutationKey = ['automationUpdateThreadMemory'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationUpdateThreadMemory>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      blockId: string;
      data: ThreadServiceUpdateThreadMemoryBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      blockId,
      data,
    } = props ?? {};

    return automationUpdateThreadMemory(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      blockId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationUpdateThreadMemoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationUpdateThreadMemory>>
>;
export type AutomationUpdateThreadMemoryMutationBody =
  ThreadServiceUpdateThreadMemoryBody;
export type AutomationUpdateThreadMemoryMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates memory block content in a thread context.
 */
export const useAutomationUpdateThreadMemory = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationUpdateThreadMemory>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        blockId: string;
        data: ThreadServiceUpdateThreadMemoryBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationUpdateThreadMemory>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    blockId: string;
    data: ThreadServiceUpdateThreadMemoryBody;
  },
  TContext
> => {
  const mutationOptions =
    getAutomationUpdateThreadMemoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns NOT_FOUND if no active plan exists.
 * @summary Gets the active plan snapshot for a thread (with per-step
statuses). Distinct from `GET /plan`, which returns the template.
 */
export const automationGetActivePlan = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetActivePlanParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Plan>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/plan/active`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetActivePlanQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  params?: AutomationGetActivePlanParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/plan/active`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetActivePlanQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetActivePlan>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetActivePlanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetActivePlan>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetActivePlanQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetActivePlan>>
  > = ({ signal }) =>
    automationGetActivePlan(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetActivePlan>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetActivePlanQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetActivePlan>>
>;
export type AutomationGetActivePlanQueryError = AxiosError<RpcStatus>;

export function useAutomationGetActivePlan<
  TData = Awaited<ReturnType<typeof automationGetActivePlan>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params: undefined | AutomationGetActivePlanParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetActivePlan>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetActivePlan>>,
          TError,
          Awaited<ReturnType<typeof automationGetActivePlan>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetActivePlan<
  TData = Awaited<ReturnType<typeof automationGetActivePlan>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetActivePlanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetActivePlan>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetActivePlan>>,
          TError,
          Awaited<ReturnType<typeof automationGetActivePlan>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetActivePlan<
  TData = Awaited<ReturnType<typeof automationGetActivePlan>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetActivePlanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetActivePlan>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets the active plan snapshot for a thread (with per-step
statuses). Distinct from `GET /plan`, which returns the template.
 */

export function useAutomationGetActivePlan<
  TData = Awaited<ReturnType<typeof automationGetActivePlan>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetActivePlanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetActivePlan>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetActivePlanQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns NOT_FOUND if no active plan exists or the phase/step index
is invalid.
Returns FAILED_PRECONDITION if the thread is currently generating,
the step is not in the active phase, or the step is already
resolved.
 * @summary Marks a step on the active plan as completed or failed.
 */
export const automationMarkStep = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  phaseIndex: number,
  stepIndex: number,
  threadServiceMarkStepBody: ThreadServiceMarkStepBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Plan>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/plan/active/phases/${phaseIndex}/steps/${stepIndex}:mark`,
    threadServiceMarkStepBody,
    options,
  );
};

export const getAutomationMarkStepMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationMarkStep>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      phaseIndex: number;
      stepIndex: number;
      data: ThreadServiceMarkStepBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationMarkStep>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    phaseIndex: number;
    stepIndex: number;
    data: ThreadServiceMarkStepBody;
  },
  TContext
> => {
  const mutationKey = ['automationMarkStep'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationMarkStep>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      phaseIndex: number;
      stepIndex: number;
      data: ThreadServiceMarkStepBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      phaseIndex,
      stepIndex,
      data,
    } = props ?? {};

    return automationMarkStep(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      phaseIndex,
      stepIndex,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationMarkStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationMarkStep>>
>;
export type AutomationMarkStepMutationBody = ThreadServiceMarkStepBody;
export type AutomationMarkStepMutationError = AxiosError<RpcStatus>;

/**
 * @summary Marks a step on the active plan as completed or failed.
 */
export const useAutomationMarkStep = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationMarkStep>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        phaseIndex: number;
        stepIndex: number;
        data: ThreadServiceMarkStepBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationMarkStep>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    phaseIndex: number;
    stepIndex: number;
    data: ThreadServiceMarkStepBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationMarkStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * No generation guard — always allowed.
Returns NOT_FOUND if no active plan exists.
Returns FAILED_PRECONDITION if the plan is not active.
 * @summary Deactivates the active plan. The snapshot is kept (flagged
inactive) for status carry-over on the next activation.
 */
export const automationDeactivatePlan = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceDeactivatePlanBody: ThreadServiceDeactivatePlanBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Plan>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/plan/active:deactivate`,
    threadServiceDeactivatePlanBody,
    options,
  );
};

export const getAutomationDeactivatePlanMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationDeactivatePlan>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeactivatePlanBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationDeactivatePlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeactivatePlanBody;
  },
  TContext
> => {
  const mutationKey = ['automationDeactivatePlan'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationDeactivatePlan>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeactivatePlanBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationDeactivatePlan(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationDeactivatePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationDeactivatePlan>>
>;
export type AutomationDeactivatePlanMutationBody =
  ThreadServiceDeactivatePlanBody;
export type AutomationDeactivatePlanMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deactivates the active plan. The snapshot is kept (flagged
inactive) for status carry-over on the next activation.
 */
export const useAutomationDeactivatePlan = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationDeactivatePlan>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDeactivatePlanBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationDeactivatePlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeactivatePlanBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationDeactivatePlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Clears all step statuses and failure reasons. If the plan is
active, it is deactivated first before resetting.
Returns NOT_FOUND if no active plan exists.
Returns FAILED_PRECONDITION if the thread is currently generating.
 * @summary Resets all step statuses on the active plan back to pending.
 */
export const automationResetPlan = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceResetPlanBody: ThreadServiceResetPlanBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Plan>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/plan/active:reset`,
    threadServiceResetPlanBody,
    options,
  );
};

export const getAutomationResetPlanMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationResetPlan>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetPlanBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationResetPlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetPlanBody;
  },
  TContext
> => {
  const mutationKey = ['automationResetPlan'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationResetPlan>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetPlanBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationResetPlan(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationResetPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationResetPlan>>
>;
export type AutomationResetPlanMutationBody = ThreadServiceResetPlanBody;
export type AutomationResetPlanMutationError = AxiosError<RpcStatus>;

/**
 * @summary Resets all step statuses on the active plan back to pending.
 */
export const useAutomationResetPlan = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationResetPlan>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceResetPlanBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationResetPlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetPlanBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationResetPlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns NOT_FOUND if no plan template exists.
Returns FAILED_PRECONDITION if the thread is currently generating,
the plan is already active, or the template has no phases.
 * @summary Activates the plan for a thread. Snapshots the current template
plan and carries over statuses from any previous snapshot by id.
 */
export const automationActivatePlan = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceActivatePlanBody: ThreadServiceActivatePlanBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Plan>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/plan:activate`,
    threadServiceActivatePlanBody,
    options,
  );
};

export const getAutomationActivatePlanMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationActivatePlan>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceActivatePlanBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationActivatePlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceActivatePlanBody;
  },
  TContext
> => {
  const mutationKey = ['automationActivatePlan'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationActivatePlan>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceActivatePlanBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationActivatePlan(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationActivatePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationActivatePlan>>
>;
export type AutomationActivatePlanMutationBody = ThreadServiceActivatePlanBody;
export type AutomationActivatePlanMutationError = AxiosError<RpcStatus>;

/**
 * @summary Activates the plan for a thread. Snapshots the current template
plan and carries over statuses from any previous snapshot by id.
 */
export const useAutomationActivatePlan = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationActivatePlan>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceActivatePlanBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationActivatePlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceActivatePlanBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationActivatePlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Read-only and observational. The queue is the to-do list of not-yet-started
work; the in-flight suspension itself lives in the event-log tail (see
GetEvents), not here. Groups are returned in drain order (head first).
 * @summary Retrieves the thread's durable queue: the deferred suspend-type work
(remote tool calls, an interrupt, a sleep, a transfer, sub-agent
task/resume) and any parked user input not yet enacted.
 */
export const automationGetQueue = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetQueueParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetQueueResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/queue`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetQueueQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  params?: AutomationGetQueueParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/queue`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetQueueQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetQueue>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetQueueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetQueue>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetQueueQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetQueue>>
  > = ({ signal }) =>
    automationGetQueue(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetQueue>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetQueueQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetQueue>>
>;
export type AutomationGetQueueQueryError = AxiosError<RpcStatus>;

export function useAutomationGetQueue<
  TData = Awaited<ReturnType<typeof automationGetQueue>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params: undefined | AutomationGetQueueParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetQueue>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetQueue>>,
          TError,
          Awaited<ReturnType<typeof automationGetQueue>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetQueue<
  TData = Awaited<ReturnType<typeof automationGetQueue>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetQueueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetQueue>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetQueue>>,
          TError,
          Awaited<ReturnType<typeof automationGetQueue>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetQueue<
  TData = Awaited<ReturnType<typeof automationGetQueue>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetQueueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetQueue>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves the thread's durable queue: the deferred suspend-type work
(remote tool calls, an interrupt, a sleep, a transfer, sub-agent
task/resume) and any parked user input not yet enacted.
 */

export function useAutomationGetQueue<
  TData = Awaited<ReturnType<typeof automationGetQueue>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetQueueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetQueue>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetQueueQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Appends a synthetic ToolCallStart (plus one ToolCallArgument per supplied
argument) to the thread event log under the generation lock, executes the
tool through the normal dispatcher, and continues with an LLM turn that
has the tool result in context. Equivalent in effect to the LLM having
chosen to call this tool itself.
 * @summary Injects a deterministic tool call into a thread.
 */
export const automationSendToolCall = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceSendToolCallBody: ThreadServiceSendToolCallBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SendToolCallResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/tool-calls`,
    threadServiceSendToolCallBody,
    options,
  );
};

export const getAutomationSendToolCallMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationSendToolCall>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendToolCallBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationSendToolCall>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendToolCallBody;
  },
  TContext
> => {
  const mutationKey = ['automationSendToolCall'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationSendToolCall>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendToolCallBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationSendToolCall(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationSendToolCallMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationSendToolCall>>
>;
export type AutomationSendToolCallMutationBody = ThreadServiceSendToolCallBody;
export type AutomationSendToolCallMutationError = AxiosError<RpcStatus>;

/**
 * @summary Injects a deterministic tool call into a thread.
 */
export const useAutomationSendToolCall = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationSendToolCall>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceSendToolCallBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationSendToolCall>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendToolCallBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationSendToolCallMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Remote tools pause generation when called, waiting for an external system
to execute them and return the result via this RPC. Generation resumes
once the result is received.
 * @summary Sends a tool execution result for a remote tool.
 */
export const automationSendToolResult = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceSendToolResultBody: ThreadServiceSendToolResultBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SendToolResultResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/tool-results`,
    threadServiceSendToolResultBody,
    options,
  );
};

export const getAutomationSendToolResultMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationSendToolResult>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendToolResultBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationSendToolResult>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendToolResultBody;
  },
  TContext
> => {
  const mutationKey = ['automationSendToolResult'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationSendToolResult>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendToolResultBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationSendToolResult(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationSendToolResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationSendToolResult>>
>;
export type AutomationSendToolResultMutationBody =
  ThreadServiceSendToolResultBody;
export type AutomationSendToolResultMutationError = AxiosError<RpcStatus>;

/**
 * @summary Sends a tool execution result for a remote tool.
 */
export const useAutomationSendToolResult = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationSendToolResult>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceSendToolResultBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationSendToolResult>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendToolResultBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationSendToolResultMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns tool details resolved with thread variables.
 * @summary Gets a single tool by its stable tool_id for a specific thread.
 */
export const automationGetTool = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params?: AutomationGetToolParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Tool>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/tools/${toolId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetToolQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  toolId?: string,
  params?: AutomationGetToolParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/tools/${toolId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetToolQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetTool>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params?: AutomationGetToolParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetTool>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetToolQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      toolId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetTool>>
  > = ({ signal }) =>
    automationGetTool(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      toolId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      agentId &&
      threadId &&
      toolId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetTool>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetToolQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetTool>>
>;
export type AutomationGetToolQueryError = AxiosError<RpcStatus>;

export function useAutomationGetTool<
  TData = Awaited<ReturnType<typeof automationGetTool>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params: undefined | AutomationGetToolParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetTool>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetTool>>,
          TError,
          Awaited<ReturnType<typeof automationGetTool>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetTool<
  TData = Awaited<ReturnType<typeof automationGetTool>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params?: AutomationGetToolParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetTool>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetTool>>,
          TError,
          Awaited<ReturnType<typeof automationGetTool>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetTool<
  TData = Awaited<ReturnType<typeof automationGetTool>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params?: AutomationGetToolParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetTool>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a single tool by its stable tool_id for a specific thread.
 */

export function useAutomationGetTool<
  TData = Awaited<ReturnType<typeof automationGetTool>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params?: AutomationGetToolParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetTool>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetToolQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    toolId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The tool executes in the context of a thread (for artifact, memory, and
plan access) but nothing is appended to thread history. Useful for testing,
automation, and external integrations.
 * @summary Invokes a tool directly without LLM involvement.
 */
export const automationInvokeTool = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceInvokeToolBody: ThreadServiceInvokeToolBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1InvokeToolResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/tools:invoke`,
    threadServiceInvokeToolBody,
    options,
  );
};

export const getAutomationInvokeToolMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationInvokeTool>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceInvokeToolBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationInvokeTool>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceInvokeToolBody;
  },
  TContext
> => {
  const mutationKey = ['automationInvokeTool'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationInvokeTool>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceInvokeToolBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationInvokeTool(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationInvokeToolMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationInvokeTool>>
>;
export type AutomationInvokeToolMutationBody = ThreadServiceInvokeToolBody;
export type AutomationInvokeToolMutationError = AxiosError<RpcStatus>;

/**
 * @summary Invokes a tool directly without LLM involvement.
 */
export const useAutomationInvokeTool = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationInvokeTool>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceInvokeToolBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationInvokeTool>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceInvokeToolBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationInvokeToolMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * When the agent has no utility generator configured this falls back
to the main generator, so the returned info always describes the
model that will actually run utility tasks.
 * @summary Gets model information and capabilities for the agent's utility
generator (the secondary generator used for thread titling and
other lightweight LLM calls around the conversation).
 */
export const automationGetUtilityGeneratorModelInfo = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetUtilityGeneratorModelInfoParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ModelInfo>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/utility-generator:model-info`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetUtilityGeneratorModelInfoQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  agentId?: string,
  threadId?: string,
  params?: AutomationGetUtilityGeneratorModelInfoParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}/utility-generator:model-info`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetUtilityGeneratorModelInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetUtilityGeneratorModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetUtilityGeneratorModelInfoQueryKey(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>
  > = ({ signal }) =>
    automationGetUtilityGeneratorModelInfo(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetUtilityGeneratorModelInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>
>;
export type AutomationGetUtilityGeneratorModelInfoQueryError =
  AxiosError<RpcStatus>;

export function useAutomationGetUtilityGeneratorModelInfo<
  TData = Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params: undefined | AutomationGetUtilityGeneratorModelInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>,
          TError,
          Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetUtilityGeneratorModelInfo<
  TData = Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetUtilityGeneratorModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>,
          TError,
          Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetUtilityGeneratorModelInfo<
  TData = Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetUtilityGeneratorModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets model information and capabilities for the agent's utility
generator (the secondary generator used for thread titling and
other lightweight LLM calls around the conversation).
 */

export function useAutomationGetUtilityGeneratorModelInfo<
  TData = Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  params?: AutomationGetUtilityGeneratorModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetUtilityGeneratorModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetUtilityGeneratorModelInfoQueryOptions(
    organization,
    workspace,
    automation,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Compaction summarizes conversation history to reduce context size while
preserving essential information. This RPC emits a CompactStart event
and returns the compact_id for tracking.

The actual compaction is performed asynchronously. Once complete, a
CompactComplete event with the summary content should be added to the
thread using the returned compact_id.

While compaction is in progress (CompactStart without CompactComplete),
the UI should block user input.
 * @summary Starts context compaction for a thread.
 */
export const automationStartCompaction = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceStartCompactionBody: ThreadServiceStartCompactionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1StartCompactionResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}:compact`,
    threadServiceStartCompactionBody,
    options,
  );
};

export const getAutomationStartCompactionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationStartCompaction>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceStartCompactionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationStartCompaction>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceStartCompactionBody;
  },
  TContext
> => {
  const mutationKey = ['automationStartCompaction'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationStartCompaction>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceStartCompactionBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationStartCompaction(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationStartCompactionMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationStartCompaction>>
>;
export type AutomationStartCompactionMutationBody =
  ThreadServiceStartCompactionBody;
export type AutomationStartCompactionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Starts context compaction for a thread.
 */
export const useAutomationStartCompaction = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationStartCompaction>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceStartCompactionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationStartCompaction>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceStartCompactionBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationStartCompactionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Dehydrates an idle thread: archives all of its data to the configured
dehydrated thread store and leaves a tombstone that still lists but cannot
generate. Returns FAILED_PRECONDITION when dehydration is not configured or
the thread is ineligible (not quiescent, queue non-empty, or sleeping).
 */
export const automationDehydrateThread = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceDehydrateThreadBody: ThreadServiceDehydrateThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}:dehydrate`,
    threadServiceDehydrateThreadBody,
    options,
  );
};

export const getAutomationDehydrateThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationDehydrateThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDehydrateThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationDehydrateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDehydrateThreadBody;
  },
  TContext
> => {
  const mutationKey = ['automationDehydrateThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationDehydrateThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDehydrateThreadBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationDehydrateThread(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationDehydrateThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationDehydrateThread>>
>;
export type AutomationDehydrateThreadMutationBody =
  ThreadServiceDehydrateThreadBody;
export type AutomationDehydrateThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Dehydrates an idle thread: archives all of its data to the configured
dehydrated thread store and leaves a tombstone that still lists but cannot
generate. Returns FAILED_PRECONDITION when dehydration is not configured or
the thread is ineligible (not quiescent, queue non-empty, or sleeping).
 */
export const useAutomationDehydrateThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationDehydrateThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDehydrateThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationDehydrateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDehydrateThreadBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationDehydrateThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Creates a new thread that is a complete copy of the source thread,
including events, feedback, memory customizations, scratchpad, plan,
and template config customizations.
Returns FAILED_PRECONDITION if the source thread is currently generating.
 * @summary Forks (duplicates) a thread with all its data.
 */
export const automationForkThread = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceForkThreadBody: ThreadServiceForkThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}:fork`,
    threadServiceForkThreadBody,
    options,
  );
};

export const getAutomationForkThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationForkThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceForkThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationForkThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceForkThreadBody;
  },
  TContext
> => {
  const mutationKey = ['automationForkThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationForkThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceForkThreadBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationForkThread(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationForkThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationForkThread>>
>;
export type AutomationForkThreadMutationBody = ThreadServiceForkThreadBody;
export type AutomationForkThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Forks (duplicates) a thread with all its data.
 */
export const useAutomationForkThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationForkThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceForkThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationForkThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceForkThreadBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationForkThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Rehydrates a dehydrated thread: restores its data from the archive and
returns it to normal operation. Returns FAILED_PRECONDITION when the thread
is not dehydrated.
 */
export const automationRehydrateThread = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceRehydrateThreadBody: ThreadServiceRehydrateThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}:rehydrate`,
    threadServiceRehydrateThreadBody,
    options,
  );
};

export const getAutomationRehydrateThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationRehydrateThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceRehydrateThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationRehydrateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceRehydrateThreadBody;
  },
  TContext
> => {
  const mutationKey = ['automationRehydrateThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationRehydrateThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceRehydrateThreadBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationRehydrateThread(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationRehydrateThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationRehydrateThread>>
>;
export type AutomationRehydrateThreadMutationBody =
  ThreadServiceRehydrateThreadBody;
export type AutomationRehydrateThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Rehydrates a dehydrated thread: restores its data from the archive and
returns it to normal operation. Returns FAILED_PRECONDITION when the thread
is not dehydrated.
 */
export const useAutomationRehydrateThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationRehydrateThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceRehydrateThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationRehydrateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceRehydrateThreadBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationRehydrateThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * If a generation is currently running, it will be cancelled and a
GenerationFailed event with STOPPED kind will be emitted. If no
generation is in progress, this is a no-op and returns stopped=false.
 * @summary Stops an in-progress generation in a thread.
 */
export const automationStop = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceStopBody: ThreadServiceStopBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1StopResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}:stop`,
    threadServiceStopBody,
    options,
  );
};

export const getAutomationStopMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationStop>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceStopBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationStop>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceStopBody;
  },
  TContext
> => {
  const mutationKey = ['automationStop'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationStop>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceStopBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationStop(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationStopMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationStop>>
>;
export type AutomationStopMutationBody = ThreadServiceStopBody;
export type AutomationStopMutationError = AxiosError<RpcStatus>;

/**
 * @summary Stops an in-progress generation in a thread.
 */
export const useAutomationStop = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationStop>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceStopBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationStop>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceStopBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationStopMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Operator-forced transfer: hand the live conversation to another profile on
the same thread (a profile swap), bypassing the agent allowlist. Triggers a
generation as the new profile; observe it via the event stream.
 */
export const automationTransfer = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceTransferBody: ThreadServiceTransferBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AutomationTransfer200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}:transfer`,
    threadServiceTransferBody,
    options,
  );
};

export const getAutomationTransferMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationTransfer>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceTransferBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationTransfer>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceTransferBody;
  },
  TContext
> => {
  const mutationKey = ['automationTransfer'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationTransfer>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceTransferBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationTransfer(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationTransfer>>
>;
export type AutomationTransferMutationBody = ThreadServiceTransferBody;
export type AutomationTransferMutationError = AxiosError<RpcStatus>;

/**
 * @summary Operator-forced transfer: hand the live conversation to another profile on
the same thread (a profile swap), bypassing the agent allowlist. Triggers a
generation as the new profile; observe it via the event stream.
 */
export const useAutomationTransfer = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationTransfer>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceTransferBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationTransfer>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceTransferBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationTransferMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Atomically ends the pending sleep with `interrupted_by_user = true`,
cancels the scheduled wake task, and triggers a new generation so the
LLM observes the early return in its rebuilt history. No-op when no
sleep is pending; the call still triggers a normal Reminder-driven
resume in that case.
 * @summary Wakes a thread that is currently sleeping (UI "Wake up" button).
 */
export const automationWake = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadId: string,
  threadServiceWakeBody: ThreadServiceWakeBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1WakeResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads/${threadId}:wake`,
    threadServiceWakeBody,
    options,
  );
};

export const getAutomationWakeMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationWake>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceWakeBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationWake>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceWakeBody;
  },
  TContext
> => {
  const mutationKey = ['automationWake'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationWake>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceWakeBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, threadId, data } =
      props ?? {};

    return automationWake(
      organization,
      workspace,
      automation,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationWakeMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationWake>>
>;
export type AutomationWakeMutationBody = ThreadServiceWakeBody;
export type AutomationWakeMutationError = AxiosError<RpcStatus>;

/**
 * @summary Wakes a thread that is currently sleeping (UI "Wake up" button).
 */
export const useAutomationWake = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationWake>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceWakeBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationWake>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceWakeBody;
  },
  TContext
> => {
  const mutationOptions = getAutomationWakeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The bulk counterpart of UpgradeThread, for re-pinning an agent's whole
fleet after a backward-incompatible version change without iterating
thread-by-thread. Threads may be narrowed by an REL `filter` (empty means
all) and are scoped to the request's parent. Each thread is upgraded
independently: one that is already current, is missing required
variables, or fails to write is reported individually and does not abort
the rest. The response carries a per-thread result and rollup counts.
 * @summary Move every thread of an agent to a target agent version in one call.
 */
export const automationUpgradeAllThreads = (
  organization: string,
  workspace: string,
  automation: string,
  agentId: string,
  threadServiceUpgradeAllThreadsBody: ThreadServiceUpgradeAllThreadsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UpgradeAllThreadsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/agents/${agentId}/threads:upgradeAll`,
    threadServiceUpgradeAllThreadsBody,
    options,
  );
};

export const getAutomationUpgradeAllThreadsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationUpgradeAllThreads>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      data: ThreadServiceUpgradeAllThreadsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationUpgradeAllThreads>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    data: ThreadServiceUpgradeAllThreadsBody;
  },
  TContext
> => {
  const mutationKey = ['automationUpgradeAllThreads'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationUpgradeAllThreads>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      agentId: string;
      data: ThreadServiceUpgradeAllThreadsBody;
    }
  > = props => {
    const { organization, workspace, automation, agentId, data } = props ?? {};

    return automationUpgradeAllThreads(
      organization,
      workspace,
      automation,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationUpgradeAllThreadsMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationUpgradeAllThreads>>
>;
export type AutomationUpgradeAllThreadsMutationBody =
  ThreadServiceUpgradeAllThreadsBody;
export type AutomationUpgradeAllThreadsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Move every thread of an agent to a target agent version in one call.
 */
export const useAutomationUpgradeAllThreads = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationUpgradeAllThreads>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        agentId: string;
        data: ThreadServiceUpgradeAllThreadsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationUpgradeAllThreads>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    agentId: string;
    data: ThreadServiceUpgradeAllThreadsBody;
  },
  TContext
> => {
  const mutationOptions =
    getAutomationUpgradeAllThreadsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Tools are resolved with thread variables, so tool availability may vary
between threads depending on variable configuration. Use this endpoint
to get the actual tools available in a thread context.

Also mirrored on `ToolCatalogService::ListTools` (same shape; the
catalog service exposes `:diff` next to it). New callers should
prefer the `ToolCatalogService` variant; this one is kept for
backwards-compatible gRPC clients.
 * @summary ============================================================================
Tool Discovery (Thread-Scoped)
============================================================================
Lists tools available to an agent for a specific thread.
 */
export const automationListTools = (
  organization: string,
  workspace: string,
  automation: string,
  v1ListToolsRequest: V1ListToolsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListToolsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/rain.v1.ThreadService/ListTools`,
    v1ListToolsRequest,
    options,
  );
};

export const getAutomationListToolsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationListTools>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: V1ListToolsRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationListTools>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: V1ListToolsRequest;
  },
  TContext
> => {
  const mutationKey = ['automationListTools'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationListTools>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: V1ListToolsRequest;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return automationListTools(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationListToolsMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationListTools>>
>;
export type AutomationListToolsMutationBody = V1ListToolsRequest;
export type AutomationListToolsMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Tool Discovery (Thread-Scoped)
============================================================================
Lists tools available to an agent for a specific thread.
 */
export const useAutomationListTools = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationListTools>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: V1ListToolsRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationListTools>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: V1ListToolsRequest;
  },
  TContext
> => {
  const mutationOptions = getAutomationListToolsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Streams live status transitions for every thread of one agent.
 */
export const automationSubscribeAgentThreadStatus = (
  organization: string,
  workspace: string,
  automation: string,
  v1SubscribeAgentThreadStatusRequest: V1SubscribeAgentThreadStatusRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AutomationSubscribeAgentThreadStatus200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/rain.v1.ThreadService/SubscribeAgentThreadStatus`,
    v1SubscribeAgentThreadStatusRequest,
    options,
  );
};

export const getAutomationSubscribeAgentThreadStatusMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationSubscribeAgentThreadStatus>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: V1SubscribeAgentThreadStatusRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationSubscribeAgentThreadStatus>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: V1SubscribeAgentThreadStatusRequest;
  },
  TContext
> => {
  const mutationKey = ['automationSubscribeAgentThreadStatus'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationSubscribeAgentThreadStatus>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: V1SubscribeAgentThreadStatusRequest;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return automationSubscribeAgentThreadStatus(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationSubscribeAgentThreadStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationSubscribeAgentThreadStatus>>
>;
export type AutomationSubscribeAgentThreadStatusMutationBody =
  V1SubscribeAgentThreadStatusRequest;
export type AutomationSubscribeAgentThreadStatusMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Streams live status transitions for every thread of one agent.
 */
export const useAutomationSubscribeAgentThreadStatus = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationSubscribeAgentThreadStatus>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: V1SubscribeAgentThreadStatusRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationSubscribeAgentThreadStatus>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: V1SubscribeAgentThreadStatusRequest;
  },
  TContext
> => {
  const mutationOptions =
    getAutomationSubscribeAgentThreadStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns a stream of events for the thread. If include_history is true,
existing events are sent first, followed by new events as they occur.
The stream stays open until the client disconnects.

This is the gRPC streaming alternative to SSE for internal clients.
 * @summary ============================================================================
Streaming Subscription
============================================================================
Subscribes to a thread's event stream.
 */
export const automationSubscribeThread = (
  organization: string,
  workspace: string,
  automation: string,
  v1SubscribeThreadRequest: V1SubscribeThreadRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AutomationSubscribeThread200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/rain.v1.ThreadService/SubscribeThread`,
    v1SubscribeThreadRequest,
    options,
  );
};

export const getAutomationSubscribeThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationSubscribeThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: V1SubscribeThreadRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationSubscribeThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: V1SubscribeThreadRequest;
  },
  TContext
> => {
  const mutationKey = ['automationSubscribeThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationSubscribeThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: V1SubscribeThreadRequest;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return automationSubscribeThread(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationSubscribeThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationSubscribeThread>>
>;
export type AutomationSubscribeThreadMutationBody = V1SubscribeThreadRequest;
export type AutomationSubscribeThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Streaming Subscription
============================================================================
Subscribes to a thread's event stream.
 */
export const useAutomationSubscribeThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationSubscribeThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: V1SubscribeThreadRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationSubscribeThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: V1SubscribeThreadRequest;
  },
  TContext
> => {
  const mutationOptions = getAutomationSubscribeThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Streams live status transitions for every thread within the caller's
parent scope (the cross-agent Threads console).
 */
export const automationSubscribeThreadStatus = (
  organization: string,
  workspace: string,
  automation: string,
  v1SubscribeThreadStatusRequest: V1SubscribeThreadStatusRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AutomationSubscribeThreadStatus200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/rain.v1.ThreadService/SubscribeThreadStatus`,
    v1SubscribeThreadStatusRequest,
    options,
  );
};

export const getAutomationSubscribeThreadStatusMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof automationSubscribeThreadStatus>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: V1SubscribeThreadStatusRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof automationSubscribeThreadStatus>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: V1SubscribeThreadStatusRequest;
  },
  TContext
> => {
  const mutationKey = ['automationSubscribeThreadStatus'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof automationSubscribeThreadStatus>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: V1SubscribeThreadStatusRequest;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return automationSubscribeThreadStatus(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AutomationSubscribeThreadStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof automationSubscribeThreadStatus>>
>;
export type AutomationSubscribeThreadStatusMutationBody =
  V1SubscribeThreadStatusRequest;
export type AutomationSubscribeThreadStatusMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Streams live status transitions for every thread within the caller's
parent scope (the cross-agent Threads console).
 */
export const useAutomationSubscribeThreadStatus = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof automationSubscribeThreadStatus>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: V1SubscribeThreadStatusRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof automationSubscribeThreadStatus>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: V1SubscribeThreadStatusRequest;
  },
  TContext
> => {
  const mutationOptions =
    getAutomationSubscribeThreadStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists threads across every agent visible to the caller's parent scope
(the cross-agent Threads console) — server-paged and searched, each
thread carrying its materialized status and its owning agent's name.
 */
export const automationListAllThreads = (
  organization: string,
  workspace: string,
  automation: string,
  params?: AutomationListAllThreadsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListAllThreadsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/threads`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationListAllThreadsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  params?: AutomationListAllThreadsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/threads`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationListAllThreadsQueryOptions = <
  TData = Awaited<ReturnType<typeof automationListAllThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: AutomationListAllThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationListAllThreads>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationListAllThreadsQueryKey(
      organization,
      workspace,
      automation,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationListAllThreads>>
  > = ({ signal }) =>
    automationListAllThreads(organization, workspace, automation, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationListAllThreads>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationListAllThreadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationListAllThreads>>
>;
export type AutomationListAllThreadsQueryError = AxiosError<RpcStatus>;

export function useAutomationListAllThreads<
  TData = Awaited<ReturnType<typeof automationListAllThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: undefined | AutomationListAllThreadsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationListAllThreads>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationListAllThreads>>,
          TError,
          Awaited<ReturnType<typeof automationListAllThreads>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationListAllThreads<
  TData = Awaited<ReturnType<typeof automationListAllThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: AutomationListAllThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationListAllThreads>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationListAllThreads>>,
          TError,
          Awaited<ReturnType<typeof automationListAllThreads>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationListAllThreads<
  TData = Awaited<ReturnType<typeof automationListAllThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: AutomationListAllThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationListAllThreads>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists threads across every agent visible to the caller's parent scope
(the cross-agent Threads console) — server-paged and searched, each
thread carrying its materialized status and its owning agent's name.
 */

export function useAutomationListAllThreads<
  TData = Awaited<ReturnType<typeof automationListAllThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: AutomationListAllThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationListAllThreads>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationListAllThreadsQueryOptions(
    organization,
    workspace,
    automation,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary The thread console's discovered filter schema: filterable fields with
operators, value types, and in-scope values with counts (agent and
origin ids carry display names). `query` scopes the counts; the active
filter is not an input.
 */
export const automationGetFilterSchema = (
  organization: string,
  workspace: string,
  automation: string,
  params?: AutomationGetFilterSchemaParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1FilterSchemaResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/threads:filter-schema`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAutomationGetFilterSchemaQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  params?: AutomationGetFilterSchemaParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/threads:filter-schema`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAutomationGetFilterSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof automationGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: AutomationGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetFilterSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAutomationGetFilterSchemaQueryKey(
      organization,
      workspace,
      automation,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof automationGetFilterSchema>>
  > = ({ signal }) =>
    automationGetFilterSchema(organization, workspace, automation, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof automationGetFilterSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AutomationGetFilterSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof automationGetFilterSchema>>
>;
export type AutomationGetFilterSchemaQueryError = AxiosError<RpcStatus>;

export function useAutomationGetFilterSchema<
  TData = Awaited<ReturnType<typeof automationGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: undefined | AutomationGetFilterSchemaParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetFilterSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetFilterSchema>>,
          TError,
          Awaited<ReturnType<typeof automationGetFilterSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetFilterSchema<
  TData = Awaited<ReturnType<typeof automationGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: AutomationGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetFilterSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationGetFilterSchema>>,
          TError,
          Awaited<ReturnType<typeof automationGetFilterSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAutomationGetFilterSchema<
  TData = Awaited<ReturnType<typeof automationGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: AutomationGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetFilterSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary The thread console's discovered filter schema: filterable fields with
operators, value types, and in-scope values with counts (agent and
origin ids carry display names). `query` scopes the counts; the active
filter is not an input.
 */

export function useAutomationGetFilterSchema<
  TData = Awaited<ReturnType<typeof automationGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: AutomationGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof automationGetFilterSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAutomationGetFilterSchemaQueryOptions(
    organization,
    workspace,
    automation,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
